import * as wind from '@/assets/img/wind.png'

export const mapTextureSet = {
  wind
}
